import { DollarSign, Plus, Trash2, History } from 'lucide-react';
import type { AporteCampaña, Miembro } from '../lib/supabase';
import { formatCurrency } from '../utils/formatters';
import { importePendienteCampana } from '../utils/fondosCampanaRpc';

interface Props {
  readonly aportes: readonly AporteCampaña[];
  readonly miembros: readonly Miembro[];
  readonly historicos: ReadonlySet<string>;
  readonly readOnly: boolean;
  readonly convocatoriaAbierta: boolean;
  readonly onNuevo: () => void;
  readonly onEntrega: (aporte: AporteCampaña) => void;
  readonly onEliminar: (aporteId: string) => void;
}

export function CompromisosCampanaList(props: Props) {
  const { aportes, miembros, historicos, readOnly, convocatoriaAbierta, onNuevo, onEntrega, onEliminar } = props;
  return <section className="rounded-xl border border-slate-200 bg-white">
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 p-5">
      <h3 className="text-lg font-bold text-slate-800">Compromisos y entregas</h3>
      {!readOnly && convocatoriaAbierta && <button onClick={onNuevo}
        className="flex items-center gap-2 rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white">
        <Plus className="h-4 w-4" />Registrar compromiso
      </button>}
    </div>
    {aportes.length === 0 && <div className="p-8 text-center text-slate-500">
      <DollarSign className="mx-auto mb-2 h-8 w-8 text-slate-300" />Sin compromisos registrados.
    </div>}
    <div className="divide-y divide-slate-100">
      {aportes.map(aporte => {
        const miembro = miembros.find(m => m.id === aporte.miembro_id);
        const nombre = miembro ? `${miembro.nombres} ${miembro.apellidos}` : aporte.nombre_externo;
        const tieneHistorial = historicos.has(aporte.id) || aporte.monto_aportado > 0;
        return <article key={aporte.id} className="p-5">
          <h4 className="font-semibold text-slate-800">{nombre || 'Aportante'}</h4>
          <div className="mt-2 grid grid-cols-1 gap-2 text-sm md:grid-cols-3">
            <p>Comprometido: <strong>{formatCurrency(aporte.monto_comprometido)}</strong></p>
            <p>Entregado: <strong>{formatCurrency(aporte.monto_aportado)}</strong></p>
            <p>Pendiente: <strong>{formatCurrency(importePendienteCampana(aporte.monto_comprometido, aporte.monto_aportado))}</strong></p>
          </div>
          {aporte.descripcion_objeto && <p className="mt-2 rounded-lg bg-blue-50 p-3 text-sm">En especie: {aporte.descripcion_objeto}</p>}
          <div className="mt-3 flex gap-3">
            <button onClick={() => onEntrega(aporte)} className="flex items-center gap-1 text-sm font-semibold text-emerald-700">
              <History className="h-4 w-4" />Entregas e historial
            </button>
            {!readOnly && !tieneHistorial && <button onClick={() => onEliminar(aporte.id)}
              className="flex items-center gap-1 text-sm text-red-700"><Trash2 className="h-4 w-4" />Eliminar compromiso impago</button>}
          </div>
        </article>;
      })}
    </div>
  </section>;
}
